import { render } from "./FarmOSRegister.vue?vue&type=template&id=0bfc12bc"
import script from "./FarmOSRegister.vue?vue&type=script&lang=js"
export * from "./FarmOSRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__